import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DualRing } from "react-loading-io";
import alert from "../Resources/img/icon-alert-yellow.png";
import RadioButtonsMoneyHooks from "./RadioButtonsMoneyHooks";
import RadioButtonsDps from "./radioButtonsDps";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import CalendarIcon from "../Resources/svg/date-picker.svg";
import {
  validatePensionPeriod,
  validateCesionComision,
  validateDefermentMonthsInputFree,
  validateTemporalYearsAsAdmin,
  validateDoublePaymentMonthsAdmin
} from "../Utils/validatorRg";
import ErrorCustom from "./errorCustom";
import { useSelector } from "react-redux";
import {
  validatorFieldPrimaRentaRG,
  calcMonthPassed
} from "../Utils/validators";
import {
  arrayYearTimeV2,
  arrayYearTime,
  arrayMonthDif,
  arrayDoublePaymentMonths,
  arrayAjusPens,
  arrayPerioBuy,
  planListRG,
  moneyType,
  temporalYearByMoneyType,
  profileTypes
} from "../Utils/constants";
import DetailsTab from "./detailsTab";
import TitleQuoteForm from "./titleQuoteForm";
import BoxNumber from "./boxNumber";
import AlertMessage from "./alertMessage";
import InputNumber from "./inputNumber";
import { mapToOptions } from "../Utils/utils";
import FormRgDinamyc from './FormElements/formRgDinamyc';
import { API } from 'aws-amplify';

function FormRgHook({
  submitValues,
  dataState,
  onClick,
  investmentProfile,
  isError,
  apiError,
  setState,
}) {
  const { clearError, setError, handleSubmit, register, watch, errors, setValue } = useForm();
  const [loading, setLoading] = useState(false);
  const [verifyMoney, setVerifyMoney] = useState(moneyType.USD);
  const [defaultValue, setDefaultValue] = useState(15000);
  const [checked, setChecked] = useState(false);
  const [dps, setDps] = useState(false);
  const [inputList, setInputList] = useState([])
  const { planes, defermentMonths, temporalYears, money_rg } = watch();
  const [showSelectOptions, setShowSelectOptions] = useState(false)
  const [clonedJsonStructure, setClonedJsonStructure] = useState();
  const [diffMonth, setDifMonth] = useState([...arrayMonthDif])
  const [selectDate, setSelectDate] = useState();
  const [errorDate, setErrorDate] = useState();
  const [stateDoublePaymentMonths, setStateDoublePaymentMonths] = useState([])

  useEffect(() => {
    getQuestionsList();
    setSelectDate(moment().format("YYYY/MM/DD"))
  }, [])

  const getQuestionsList = async () => {

    const response = await API.post('api-rentas', '/quiz', {
      body: { section: 'COTI#PLAN' }
    });

    if (response.status) {
      setInputList(response.data)
      let clone = JSON.parse(JSON.stringify(response.data))
      setClonedJsonStructure(clone)
    }
  }

  let channel = useSelector((state) => state.login.channel);
  channel = ['admin', 'renta'].includes(channel) ? channel : profileTypes.RENTA;

  useEffect(() => {
    if (temporalYears) {
      const filterDoublePaymentMonths = arrayDoublePaymentMonths.filter(months => months.value < temporalYears * 12);
      setStateDoublePaymentMonths([...filterDoublePaymentMonths])
    }
  }, [temporalYears])

  const onSubmit = (values) => {
    if (!errorDate) {
      const valuesReq = { ...values, fechaInicioDevengue: moment(selectDate).format("DD/MM/YYYY") }
      const data = {
        ...valuesReq,
        channel,
      };
      submitValues(data);
    }

  };

  useEffect(() => {
    if (channel == profileTypes.RENTA) {
      if (money_rg == moneyType.USD) {
        setValue('temporalYears', temporalYearByMoneyType.USD)
      }
      else {
        setValue('temporalYears', temporalYearByMoneyType.PEN)
      }
    }
  }, [money_rg]);

  useEffect(() => {
    const initValue = verifyMoney === "USD" ? 15000 : 50000;
    setDefaultValue(initValue);
  }, [verifyMoney]);

  useEffect(() => {
    setValue('capitalSupervivencia', 0, true);
    setValue('capitalFallecimiento', 0);
    setValue('premiumRefund', 0)

    if (planes === planListRG.PLAN_PENSION_PERMANENTE || channel === profileTypes.ADMIN) {
      setShowSelectOptions(false)

    } else {
      setShowSelectOptions(true)
    }
  }, [planes])


  useEffect(() => {
    if (temporalYears >= 2 && defermentMonths >= 0) {
      const result = (temporalYears * 12) - defermentMonths
      setValue('periodoGaranzitado', result)
    }
    if (channel !== "admin") {
      if (temporalYears) {
        const result = (temporalYears * 12);
        const newListDiffMonth = arrayMonthDif.filter(element => element.value < result)
        setDifMonth([...newListDiffMonth])
      }
    }
  }, [temporalYears, defermentMonths])

  const handleUpdateStateInput = (inputListToUpdate) => {
    clearError();
    let inputListState = inputList;
    inputListState.forEach((element, index) => {
      let findElement = inputListToUpdate.find(el => el.inputName === element.metadata.inputName)
      if (findElement) {
        const { isRequire, isVisible, isEnable, checked = false, defaulValue = 0 } = findElement
        element.metadata.isRequire = isRequire;
        element.metadata.isVisible = isVisible;
        element.metadata.isEnable = isEnable;
        element.metadata.checked = checked;
        element.metadata.defaulValue = defaulValue;

        if (element.metadata.setting.options && findElement.options) {
          element.metadata.setting.options = findElement.options
        }

        if (element.metadata.setting && findElement.setting) {
          element.metadata.setting = { ...element.metadata.setting, ...findElement.setting }
        }

      } else {
        if (element.metadata.setting.options) {
          element.metadata.setting.options = clonedJsonStructure[index].metadata.setting.options;
        }
      }
    })
    setInputList([...inputListState])
  }

  const handleUpdateStateByInput = (item, newState) => {

    let inputListState = inputList;
    inputListState.forEach((element) => {
      if (element.metadata.inputName === item.metadata.inputName) {
        element.metadata.checked = newState;
      }
    })
    setInputList([...inputListState])

  }

  const handleDateChange = (initDate) => {
    const dateCalcWithCurrentDate = calcMonthPassed(initDate)
    if (dateCalcWithCurrentDate <= -1 || dateCalcWithCurrentDate > 1) {
      setErrorDate(`La fecha devengue no debe ser mayor o menor a 2 meses de la fecha actual.`);
      setSelectDate(initDate)
    }
    else {
      setErrorDate(null)
      setSelectDate(initDate)
    }
  };

  const maxDate = new Date()

  return (
    <div className="vasForm">
      <TitleQuoteForm
        title="Renta Garantizada"
        subtitle="Obtén la cotización en unos minutos"
      />
      <DetailsTab
        dataState={dataState}
        list={true}
        onClick={onClick}
        customerProgetValuesfile={investmentProfile}
      />
      <form onSubmit={handleSubmit(onSubmit)} className="vasForm__form">

        <div className="vasForm__form__input-container">
          <label>Capital</label>
          <RadioButtonsMoneyHooks
            name="money_rg"
            register={register}
            setVerifyMoney={setVerifyMoney}
            enableMoneyPEN={true}
            setState={setState}
          />
          <BoxNumber
            setValue={setValue}
            register={register}
            initCounter={defaultValue}
            nameVal="capital"
            verifyMoney={verifyMoney}
            incrementValue={1000}
            validatorInput={validatorFieldPrimaRentaRG}
          />
          <ErrorCustom errors={errors} name="capital" />
        </div>
        {inputList.length > 0 && <FormRgDinamyc setError={setError} clearError={clearError} useRoll={channel} errors={errors} currency={verifyMoney} handleChangeRadius={(e, newValue) => handleUpdateStateByInput(e, newValue)} data={inputList} setValue={setValue} register={register} handleOnChange={(inputListToUpdate) => handleUpdateStateInput(inputListToUpdate)} />}
        <div className="vasForm__form__input-container-selector align-items-start">
          {<><div className="vasForm__form__input-container-select">
            <label>Años Temporal</label>
            {channel === "admin" ? (<>

              <InputNumber
                id="temporalYears"
                nameVal="temporalYears"
                setValue={setValue}
                register={register}
                prefix={''}
                validatorInput={(value) => validateTemporalYearsAsAdmin(value, clearError, 'temporalYears')}
                init={0}
              />

              <ErrorCustom errors={errors} name="temporalYears" />

            </>
            ) : (<>

              <select
                id="temporalYears"
                name="temporalYears"
                ref={register}
              >
                {money_rg == moneyType.USD ?
                  <>
                    {mapToOptions(arrayYearTime).length && mapToOptions(arrayYearTime).map(({ value }) => (
                      <option key={value} value={value}>{value}</option>
                    ))}
                  </> : <>{mapToOptions(arrayYearTimeV2).length && mapToOptions(arrayYearTimeV2).map(({ value }) => (
                    <option key={value} value={value}>{value}</option>
                  ))}</>}
              </select>
              <ErrorCustom errors={errors} name="temporalYears" />
            </>
            )}
          </div>
            <div className="vasForm__form__input-container-select">
              <label>Meses diferimiento</label>
              {channel === "admin" ? (<InputNumber
                id="defermentMonths"
                nameVal="defermentMonths"
                setValue={setValue}
                register={register}
                prefix={''}
                validatorInput={(value) => validateDefermentMonthsInputFree(value, temporalYears, clearError, 'defermentMonths')}
                init={0}
              />) : (
                <select
                  id="defermentMonths"
                  name="defermentMonths"
                  ref={register}
                >
                  {mapToOptions(diffMonth).length &&
                    mapToOptions(diffMonth).map(({ label, value, disabled }) => (
                      <option key={label} disabled={disabled} value={value === '' ? 0 : value}>{label}</option>
                    ))}
                </select>
              )}
              <ErrorCustom errors={errors} name="defermentMonths" />
            </div></>}
        </div>
        {<><div className="vasForm__form__input-container-selector align-items-start">
          <div className="vasForm__form__input-container-select">
            <label>Meses doble pago</label>
            {channel === "admin" ? (
              <InputNumber
                id="doublePaymentMonths"
                nameVal="doublePaymentMonths"
                setValue={setValue}
                register={register}
                prefix={''}
                validatorInput={(value) => validateDoublePaymentMonthsAdmin(value, clearError, 'doublePaymentMonths', temporalYears)}
                init={0}
              />) : (
              <select
                id="doublePaymentMonths"
                name="doublePaymentMonths"
                ref={register}
              >
                {mapToOptions(stateDoublePaymentMonths).length &&
                  mapToOptions(stateDoublePaymentMonths).map(({ label, value }) => (
                    <option key={label} value={value === '' ? 0 : value}>{label}</option>
                  ))}
              </select>
            )}
            <ErrorCustom errors={errors} name="doublePaymentMonths" />
          </div>
          <div className="vasForm__form__input-container-select">
            <label>Ajuste de pensión</label>
            <select id="ajuste_pension" name="ajuste_pension" ref={register}>
              {mapToOptions(arrayAjusPens).length &&
                mapToOptions(arrayAjusPens).map(({ value }) => (
                  <option key={value} value={value}>{value === "true" ? "Si" : "No"}</option>
                ))}
            </select>

            <ErrorCustom errors={errors} name="ajuste_pension" />
          </div>
        </div></>}
        <div className="vasForm__form__input-container-select">
          <label>% Cesión de comisión (0-100)</label>
          <InputNumber
            id="cesion_comision"
            nameVal="cesion_comision"
            setValue={setValue}
            register={register}
            suffix={'%'}
            validatorInput={(value) => validateCesionComision(value, clearError, 'cesion_comision')}
            init={0}
          />
          <ErrorCustom errors={errors} name="cesion_comision" />
        </div>
        <div className="vasForm__form__input-container-select">
          <label>Periodicidad de pago</label>
          <select id="pensionPeriod" name="pensionPeriod"
            ref={register({ validate: validatePensionPeriod })}
          >
            {mapToOptions(arrayPerioBuy).length &&
              mapToOptions(arrayPerioBuy).map(({ label, value }) => (
                <option key={label} value={value}>{label}</option>
              ))}
          </select>
          <ErrorCustom errors={errors} name="pensionPeriod" />
        </div>

        {channel === "admin" && <div className="vasForm__form__input-container-select">
          <label>Fecha devengue</label>
          <div className={`datapicker-single ${errorDate && "is-error"}`}>
            <div className="datapicker-single__body">
              <DateTimePicker
                name="fechaInicioDevengue"
                value={selectDate}
                format="dd-MM-yy"
                dayPlaceholder="dd"
                monthPlaceholder="mm"
                yearPlaceholder="yy"
                onChange={(e) => handleDateChange(e)}
                calendarIcon={
                  <img src={CalendarIcon} />
                }
                clearIcon={null}
                maxDate={maxDate}
              />
            </div>
          </div>
          {errorDate && <div className="errorCustom">{errorDate}</div>}
        </div>}


        <div className="vasForm__form__input-container-dps-counter__portafolio">
          <label>¿El asegurado cuenta con DPS afirmativa?</label>
          <div className="vasForm__form__input-container-dps-counter__portafolio__container">
            <RadioButtonsDps
              name="dpsAfirma"
              register={register}
              setDps={setDps}
              setChecked={setChecked}
              id="dpsAfirma"
            />
          </div>
        </div>
        <div className="vasForm__form__input-container-dps-counter__portafolio">
          <label>¿Es fumador?</label>
          <div className="vasForm__form__input-container-dps-counter__portafolio__container">
            <RadioButtonsDps
              name="isSmoker"
              register={register}
              setDps={setDps}
              setChecked={setChecked}
              id="isSmoker"
            />
          </div>
        </div>
        <br />
        {isError && (
          <div className="vasForm__form__btn-container">
            <AlertMessage
              background="#FFEFD8"
              icono={alert}
              mensaje="Llegaste al límite máximo de cotizaciones, limpia la tabla de cotizaciones para crear una nueva cotización."
            />
          </div>
        )}
        {apiError && (
          <div className="vasForm__form__btn-container">
            <AlertMessage
              background="#FFEFD8"
              icono={alert}
              mensaje={apiError}
            />
          </div>
        )}
        <div className="vasForm__form__btnew-group">
          <button id="button_quote_vas" type="submit" className="btn btnew">
            Cotizar
          </button>
        </div>
      </form>
      {loading && (
        <div className="loading-field">
          <DualRing size={50} />
        </div>
      )}
    </div>
  );
}

export default FormRgHook;